<template>
  <div>
    <h2
      v-if="name"
      v-text="name"
    />
    <publications
      type="articles"
      :section-id="id"
      detail-route-name="ArticleDetail"
      more-text="Узнать больше"
    />
  </div>
</template>

<script>
import Publications from '../components/Publications'
import apiService from '../apiService'
import breadcrumbs from '../mixins/breadcrumbs'

export default {
  name: 'Articles',
  components: { Publications },
  mixins: [breadcrumbs],
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      name: ''
    }
  },
  mounted () {
    this.fetchSections()
  },
  methods: {
    fetchSections () {
      apiService.getArticlesSections()
        .then(response => {
          this.name = response.data.DATA[this.id].NAME || ''

          this.$title = this.name
          this.breadcrumbTitleUpdate('ArticlesSection', this.name)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
h2 {
  float: left;
}
</style>
